<template>
  <div
    class="lg:max-h-full flex flex-col w-full gap-4"
    :class="{ 'md:flex-row': !col }"
  >
    <section
      class=" flex flex-col my-auto text-center"
      :class="{ 'md:text-left md:w-1/2': !col }"
    >
      <div class="mb-4">
        <h1>
          <slot />
        </h1>
      </div>
      <div v-if="sottoTitolo" class="mb-4 prose" v-html="sottoTitolo" />
      <div
        v-if="descrizione"
        class=" prose"
        v-html="descrizione"
        :class="{ 'mb-4': !note }"
      />
      <div v-if="note" class="mb-4 text-sm" v-html="note" />

      <div v-if="iconList" class="mb-4">
        <p v-text="iconList.listTitle" class="mb-2 prose" />
        <div class="md:justify-start grid justify-center gap-1">
          <img
            v-for="image in [iconList.iconImage]"
            :key="image"
            :src="image"
            class="h-8"
          />
        </div>
      </div>

      <div v-if="claim" class="text-primary mb-4" v-text="claim" />

      <app-cta-button class="md:mx-0 mx-auto" v-if="cta" v-bind="cta" />
    </section>
    <section
      class=" relative h-full my-auto overflow-hidden"
      :class="{ 'md:w-1/2': !col }"
    >
      <div
        class="md:justify-center flex flex-col w-full h-full p-4 my-auto overflow-hidden"
      >
        <template v-if="navigate">
          <app-navigation-carets :navigate="navigate">
            <div class=" w-full mx-auto my-auto">
              <slot name="right">
                <img
                  class="max-h-96 object-contain mx-auto"
                  :class="{ 'md:float': !imageDescription }"
                  :src="
                    images
                      ? images[isMobile && images.mobile ? 'mobile' : 'desktop']
                      : image
                  "
                />
                <p v-if="imageDescription" v-html="imageDescription" />
              </slot>
            </div>
          </app-navigation-carets>
        </template>
        <template v-else>
          <slot name="right">
            <img
              class="max-h-96 object-contain mx-auto"
              :class="{ 'md:float': !imageDescription }"
              :src="
                images
                  ? images[isMobile && images.mobile ? 'mobile' : 'desktop']
                  : image
              "
            />
            <p v-if="imageDescription" v-html="imageDescription" />
          </slot>
        </template>
      </div>
    </section>
  </div>
</template>
<script>
import AppCtaButton from "@/components/nav/AppCtaButton";

export default {
  components: { AppCtaButton },
  props: {
    navigate: Function,
    sottoTitolo: String,
    descrizione: String,
    claim: String,
    note: String,
    iconList: Object,
    cta: Object,
    images: Object,
    image: String,
    imageDescription: String,
    col: Boolean
  }
};
</script>
